import BlurCircularIcon from '@mui/icons-material/BlurCircular';
import ForestOutlinedIcon from '@mui/icons-material/ForestOutlined';
import TagIcon from '@mui/icons-material/Tag';
import type {SxProps} from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import {lighten} from '@mui/system/colorManipulator';
import type {FC} from 'react';
import {useTranslation} from 'react-i18next';
import ValueLabel from '@/components/common/ValueLabelForPopUp';
import type {Species} from '@/domain/entities/Species';
import type {InventoryPlotMapFeatureProps} from '@/domain/utils/getGeoJsonFromInventoryPlots';
import {primaryColor} from '@/theme/theme';

//TYPES
type Props = {
  species: Array<Species>;
  inventoryPlotMapFeatureProps: InventoryPlotMapFeatureProps;
  onClick: (uuid: string) => void;
};

const InventoryPlotPopupContent: FC<Props> = ({species, inventoryPlotMapFeatureProps, onClick}) => {
  const {t} = useTranslation();
  const {uuid, code, diameter, speciesUuid} = inventoryPlotMapFeatureProps;

  const inventoryPlotSpecies = species.find((s) => s.uuid === speciesUuid)?.nameKey || '-';

  return (
    <Box sx={styles.container}>
      <Stack direction="column" sx={{m: 0}}>
        {code && (
          <ValueLabel
            value={code.toUpperCase()}
            icon={<TagIcon sx={{color: 'grey.700'}} />}
            label={t('inventoryPlots.code')}
          />
        )}
        <Divider />
        {diameter && (
          <ValueLabel
            value={diameter.toString()}
            icon={<BlurCircularIcon sx={{color: 'grey.700'}} />}
            label={t('inventoryPlots.diameter')}
          />
        )}
        <Divider />
        {inventoryPlotSpecies && (
          <ValueLabel
            value={inventoryPlotSpecies}
            icon={<ForestOutlinedIcon sx={{color: 'grey.700'}} />}
            label={t('inventoryPlots.species')}
          />
        )}
        <Button
          variant="contained"
          sx={{bgcolor: lighten(primaryColor, 0.5), color: 'primary.main', mt: 1}}
          onClick={() => onClick(uuid)}
        >
          {t('inventoryPlots.viewDetail')}
        </Button>
      </Stack>
    </Box>
  );
};
export default InventoryPlotPopupContent;

const styles: Record<string, SxProps> = {
  container: {
    width: 'auto',
    boxSizing: 'border-box',
    margin: '0px',
  },
};
